module.exports = __webpack_public_path__ + "play_main.d9d0a5ea.png";